import { SR_API_ACTION_CONCESSIONS_GET_BY_LISTING_ID } from 'api/actionTypes';

export default async function getByListingId({ state, apiClient }, { listingId, forceReload }) {
  const statePath = ['concessions', 'byListingId', listingId];

  if (state.get(statePath) && !forceReload) {
    return state.get(statePath);
  }
  return apiClient.postWithState({
    action: SR_API_ACTION_CONCESSIONS_GET_BY_LISTING_ID,
    state: state,
    queryId: listingId,
    payload: {
      listingId,
    },
    onSuccess(concession) {
      state.set(statePath, concession);
    },
  });
}
